import { InteractionRequiredAuthError } from '@azure/msal-browser';

export const authFetch = (msalInstance, url, options = {}, autoReload = false) => {
    // If auth is disabled for staging
    if (process.env.REACT_APP_AUTH_ENABLED === 'false' || !msalInstance) {
        return fetch(url, options);
    }

    const accounts = msalInstance.getAllAccounts();
    const tokenRequest = {
        scopes: ["openid", "profile"],
        account: accounts[0],
        forceRefresh: false // The first call is made without forced token refresh, using the cached token
    };

    return msalInstance.acquireTokenSilent(tokenRequest)
        .then(response => 
            fetch(url, {
                ...options,
                headers: {
                    'Authorization': `Bearer ${response.idToken}`,
                    ...options.headers
                }
            })
        ).then(response => {
            if (response.status === 401) {
                // The token is expired, so we will try a forced refresh once. If it still is not working we will refresh the page
                tokenRequest.forceRefresh = true;
                return msalInstance.acquireTokenSilent(tokenRequest)
                    .then(newResponse => 
                        fetch(url, {
                            ...options,
                            headers: {
                                'Authorization': `Bearer ${newResponse.idToken}`,
                                ...options.headers
                            }
                        })
                    );
            }
            return response
        })
        .then(response => {
            if (response.status === 401) {
                if (autoReload) {
                    alert('Your session has expired. You can refresh the page to prompt login...');
                    //window.location.reload();
                }
                throw new Error('AUTH_EXPIRED');
            }
            return response;
        })
        .catch(error => {
            if (error instanceof InteractionRequiredAuthError) {
                if (autoReload) {
                    alert('Your session has expired. You can refresh the page to prompt login...');
                    //window.location.reload();
                }
                throw new Error('AUTH_EXPIRED');
            }
            throw error;
        });
};